import { useAppSelector } from "@store/hooks";
import { selectNewJobForm } from "@store/slices/newJobFormSlice";

import NewJobForm from "./NewJobForm";
import NewJobSubmissionDialog from "./NewJobSubmissionDialog";

function NewJob() {
  const newJob = useAppSelector(selectNewJobForm);

  return (
    <>
      <NewJobForm />
      {["STATUS_POLLING", "SUCCESS", "ERROR_AFTER_SUBMIT"].includes(
        newJob.state,
      ) && <NewJobSubmissionDialog />}
    </>
  );
}

export default NewJob;
